import { fetchApi } from "../fetchApi";

export async function updateAddress(matchedAddress) {
  // console.log("matchedAddress", matchedAddress);
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: matchedAddress,
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    headers: { "Content-Type": "application/json" },
  };

  const endpoint = "/mini-store/address/update";

  let response = await fetchApi({ requestOptions, endpoint });
  response = await JSON.parse(response);
  return response.result;
}
